import React from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import { dateRange, isMeetLive, titleFit } from './meetDates';

const LIVE_RESULTS = 'https://liveresults.asaj.com.jm';

// Home page hero: the first meet in the listing (query: upcoming Events,
// soonest first, limit 1). Shows the meet's preview image; without one,
// the crest (no stock team photo: it would misrepresent most meets).
const HeroTemplate = ({ items, isEditMode }) => {
  const meet = items[0];
  if (!meet) return null;
  const live = isMeetLive(meet);
  const { range, year } = dateRange(meet.start, meet.end);

  return (
    <section className="asaj-hero" aria-label={live ? 'Live now' : 'Next meet'}>
      <div className="asaj-hero-inner">
        <div className="asaj-hero-copy">
          <span className="asaj-hero-tagline">
            {live ? 'Live now' : 'Next meet'} · {range} {year}
          </span>
          <h2 className="asaj-display" style={titleFit(meet.title)}>
            {meet.title}
          </h2>
          {meet.description && <p>{meet.description}</p>}
          <div className="asaj-btns">
            {live && (
              <a
                className="asaj-btn asaj-btn-live"
                href={LIVE_RESULTS}
                target="_blank"
                rel="noopener noreferrer"
              >
                Follow live results
              </a>
            )}
            <ConditionalLink
              item={meet}
              condition={!isEditMode}
              className={`asaj-btn ${live ? '' : 'asaj-btn-gold'}`}
            >
              Meet information
            </ConditionalLink>
          </div>
        </div>
        <div
          className={`asaj-hero-photo${meet.image_field ? '' : ' is-empty'}`}
        >
          {meet.image_field && (
            <Component componentName="PreviewImage" item={meet} alt="" />
          )}
        </div>
      </div>
      <span className="asaj-flag" aria-hidden="true" />
    </section>
  );
};

export default HeroTemplate;
